import { Route } from "react-router";
import {
  CLONE_PRODUCT,
  EDIT_PRODUCT,
  NEW_PRODUCT,
  PRODUCT,
  PRODUCTS,
} from "@routes/routes";
import {
  ProductHeaderLayout,
  ProductCopyPage,
  ProductEditPage,
  ProductNewPage,
  ProductViewPage,
  ProductsPage,
} from "@routes/lazyPages";

/** Products — list, preview, editor and copy. */
export const productRoutes = (
  <>
    <Route path={PRODUCTS} lazy={ProductsPage} />
    <Route path={NEW_PRODUCT} lazy={ProductNewPage} />
    <Route lazy={ProductHeaderLayout}>
      <Route path={PRODUCT} lazy={ProductViewPage} />
      <Route path={EDIT_PRODUCT} lazy={ProductEditPage} />
      <Route path={CLONE_PRODUCT} lazy={ProductCopyPage} />
    </Route>
  </>
);
